
import { ResponsiveIframe } from '../layouts/ResponsiveIframe.js';

export const Event = {
  onLoad: function() {
    if ($('.single-event').length) {
      ResponsiveIframe.onLoad();
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/modules/Event.js